var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoBespokeBenefits9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_10013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4375 64.9346L34.5 66.979L21.5625 64.9346C24.0826 64.9346 26.2645 63.1853 26.813 60.7258L28.7563 51.9971H40.2437L42.187 60.7258C42.7355 63.1853 44.9174 64.9346 47.4375 64.9346Z",
    fill: "#D6D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4375 64.9346L34.5 66.979V51.9971H40.2437L42.187 60.7258C42.7355 63.1853 44.9174 64.9346 47.4375 64.9346Z",
    fill: "#A9AACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2607 64.957H50.7393V69H18.2607V64.957Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 64.957H50.7393V69H34.5V64.957Z",
    fill: "#D6D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 47.1841V55.8091H0V47.1841L34.5 44.6963L69 47.1841Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 47.1841V55.8091H34.5V44.6963L69 47.1841Z",
    fill: "#D6D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.37207V47.1846H69V8.37207H0Z",
    fill: "#4E588B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 8.37207H69V47.1846H34.5V8.37207Z",
    fill: "#293E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04297 12.415H64.957V43.1416H4.04297V12.415Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12.415H64.957V43.1416H34.5V12.415Z",
    fill: "#D6D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.518 5.00654V24.4573C49.518 32.7521 34.4997 40.0483 34.4997 40.0483C34.4997 40.0483 19.4814 32.7521 19.4814 24.4573V5.00654C24.488 5.00654 27.5323 3.62654 29.4932 0H39.5063C41.3418 3.65619 44.5115 5.00654 49.518 5.00654Z",
    fill: "#BDE953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5183 5.00654V24.4573C49.5183 32.7521 34.5 40.0483 34.5 40.0483V0H39.5065C41.3421 3.65619 44.5117 5.00654 49.5183 5.00654Z",
    fill: "#00CD72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2831 15.6299L32.9385 25.9745L25.7178 18.7551L28.5775 15.8954L32.9385 20.2564L40.4234 12.7715L43.2831 15.6299Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2827 15.6299L34.5 24.4125V18.6944L40.423 12.7715L43.2827 15.6299Z",
    fill: "#D6D6EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_10013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoBespokeBenefits9);
export default __webpack_public_path__ + "static/media/products_bruno_bespoke_benefits_9.b7643f0a9129d7f1f8d821ca4bcb5166.svg";
export { ForwardRef as ReactComponent };